<script>
import {supabase} from "./supabaseClient"
import router from 'page'
import { fade } from 'svelte/transition';

import StandardHeader from "./StandardHeader.svelte"
import StandardFooter from "./StandardFooter.svelte"

const handleSignOut = async () => {
  let { error } = await supabase.auth.signOut()
}

let email;
let formSubmitted = false;
let errorMessage ='';

const handleRequestLoginWithEmail = async () => {
  debugger;
  const { data, error } = await supabase.auth.signInWithOtp({
    email: email,
    options: {
      // set this to false if you do not want the user to be automatically signed up
      shouldCreateUser: false,
      emailRedirectTo:  window.location.origin + '/EmailSigninRedirect/',
    },
  })

    if (error) {
        console.error('Error sending magic link:', error)
        errorMessage = error.message;
    } else {
        console.log('Magic link sent to:', email)
        formSubmitted = true;
    }
  }
</script>

<div class="pageContainer">
  <StandardHeader />
  <div class="mainContentSection" style="min-width:300px">
    
    <div style="align-self: flex-start"><b>Sign In with Email</b></div>
     {#if !formSubmitted}
       <form on:submit|preventDefault={handleRequestLoginWithEmail} style="width:100%; max-width: 360px" id="Login">
        <div><input type="email" placeholder="Email" bind:value={email} style="width:100%" on:input={() => errorMessage=''} /> </div>

        {#if errorMessage != ''}
            <div style="color:red" in:fade="{{ y: 200, duration: 1500 }}">{errorMessage}</div>
        {/if}
        <div><button id="LoginButton" class="primary" style="float:right" type="submit">Email me a link</button>
        </form>
      {:else}
       <div>We've sent you a link to sign in via email.</div>
       <div>Please check your email (including any spam folders.) </div>
       <div>You can close this page now.</div>
      {/if}
    </div>
    
    <div style="text-align:center"><a href="/RequestPasswordReset">Forgot your Password?</a></div>


  <StandardFooter/>
</div>

<style>
.pageContainer{min-height:100vh;  display: flex; flex-direction: column; }
.mainContentSection {min-height: calc(100vh - 200px);  display: flex; flex-direction: column; align-self: center; justify-content: center}
</style>
